export default __webpack_public_path__ + "static/media/offers.f0fc4713.svg";